import { render } from "./SelectExcel.vue?vue&type=template&id=9eff945c"
import script from "./SelectExcel.vue?vue&type=script&lang=ts"
export * from "./SelectExcel.vue?vue&type=script&lang=ts"
script.render = render

export default script